import { JSX } from "react";
import { cn } from "@/shared/utils";

type Colors = "green" | "red" | "orange-100";

interface Props {
  text: string;
  color?: Colors;
  prefix?: JSX.Element;
  suffix?: JSX.Element;
  className?: string;
}

const CommonBadge = ({ text, color = "green", className, prefix, suffix }: Props) => {
  const badgeColors: Record<Colors, string> = {
    green: "bg-green",
    red: "bg-red",
    "orange-100": "bg-orange-100",
  };
  return (
    <div
      className={cn(
        `${badgeColors[color]} px-1 py-0.5 rounded-full uppercase text-xs font-bold leading-3 text-white flex items-center whitespace-nowrap`,
        className
      )}
    >
      {prefix}
      {text}
      {suffix}
    </div>
  );
};

export default CommonBadge;